"use strict";

import {IConfig, globalObj} from "../config";
var extend = require("extend");

var segmentInited = false;

const options = () => {
    const isAdminRoute = window.location.pathname.indexOf("/edit") !== -1;
    return {
        integrations: {
          Chameleon: isAdminRoute,
          Intercom: isAdminRoute
        }
      }
};
export class AnalyticsSink {
    constructor(config: IConfig) {
        this.buildSegment(config);
    }

    private buildSegment(config: IConfig) {
        if (!segmentInited) {
            var segmentWriteKey = config.segmentWriteKey,
                defineSegment;


            // https://segment.com/docs/sources/website/analytics.js/quickstart/
            defineSegment =  (writeKey) => {


                // Create a queue, but don't obliterate an existing one!
                var analytics = globalObj.analytics = globalObj.analytics || [];

                // If the real analytics.js is already on the page return.
                if (analytics.initialize) return;

                // If the snippet was invoked already show an error.
                if (analytics.invoked) {
                    if (globalObj.console && console.error) {
                        console.error('Segment snippet included twice.');
                    }
                    return;
                }

                // Invoked flag, to make sure the snippet
                // is never invoked twice.
                analytics.invoked = true;

                // A list of the methods in Analytics.js to stub.
                analytics.methods = [
                    'trackSubmit',
                    'trackClick',
                    'trackLink',
                    'trackForm',
                    'pageview',
                    'identify',
                    'reset',
                    'group',
                    'track',
                    'ready',
                    'alias',
                    'debug',
                    'page',
                    'once',
                    'off',
                    'on'
                ];

                // Define a factory to create stubs. These are placeholders
                // for methods in Analytics.js so that you never have to wait
                // for it to load to actually record data. The `method` is
                // stored as the first argument, so we can replay the data.
                analytics.factory = function(method){
                    return function(){
                        var args = Array.prototype.slice.call(arguments);
                        args.unshift(method);
                        analytics.push(args);
                        return analytics;
                    };
                };

                // For each of our methods, generate a queueing stub.
                for (var i = 0; i < analytics.methods.length; i++) {
                    var key = analytics.methods[i];
                    analytics[key] = analytics.factory(key);
                }

                // Define a method to load Analytics.js from our CDN,
                // and that will be sure to only ever load it once.
                analytics.load = function(key, loadOptions){
                    // Create an async script element based on your key.
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = ('https:' === document.location.protocol
                        ? 'https://' : 'http://')
                        + 'cdn.segment.com/analytics.js/v1/'
                        + key + '/analytics.min.js';

                    // Insert our script next to the first script element.
                    var first = document.getElementsByTagName('script')[0];
                    first.parentNode.insertBefore(script, first);
                    analytics._loadOptions = loadOptions;
                };

                // Add a version to keep track of what's in the wild.
                analytics.SNIPPET_VERSION = '4.1.0';

                // Load Analytics.js with your key, which will automatically
                // load the tools you've enabled for your account. Boosh!
                try {
                    analytics.load(writeKey, options());
                }
                catch (err) {
                    if (globalObj.console && console.error) {
                        console.error('Error loading segment script');
                    }
                }

                // Make the first page call to load the integrations. If
                // you'd like to manually name or tag the page, edit or
                // move this call however you'd like.
                analytics.page();
            };

            defineSegment(segmentWriteKey);
            segmentInited = true;
        }
    }

    _segment(method, ...fields: any[]) {
        return globalObj.analytics[method].apply(globalObj.analytics, fields);
    }

    identify(userId: string, profile) {
        var This = this;
        //This._ga("set", "&uid", userId);
        var properties;
        if (profile) {
            properties = {
                email: profile.email,
                emailVerified: profile.email_verified,
                createdAt: profile.created_at,
                lastLoginTime: profile.lastLoginTime || profile.last_login,
                name: profile.name,
                lastName: profile.family_name,
                firstName: profile.given_name,
                nickname: profile.nickname,
                locale: profile.locale,
                avatar: profile.picture,
                devices: profile.devices, // facebook
                gender: profile.gender, // facebook
                clientId: profile.clientID,
                globalClientId: profile.global_client_id,
                ...options()
            };
        }
        if (globalObj.Appcues) {
            globalObj.Appcues.identify(userId, properties);
        }

        This._segment("identify", userId, properties, function(){
            return Promise.resolve();
        });
    }

    dimension(index: number, value: any) {
        // Not used with Segment, bc dimension is set using identify
        // This._ga("set", "dimension" + index, value);
        return Promise.resolve();
    }

    event(category: string, action: string, label: string, value: number, extraInfo: any, eventId: string) {
        var This = this;
        return new Promise(function (resolve) {
            //This._ga("send", "event", {
            //    "eventCategory": category,
            //    "eventAction": action,
            //    "eventLabel": label || "",
            //    "eventValue": value || 0 // redundant if value already === 0 but oh well
            //});
            var properties = extend({}, extraInfo, {category: category, label: label, value: value, eventId: eventId}, options());
             This._segment("track", action, properties, function(){
                //window.alert("event: action: " + action + "; category:" + category);
                return resolve();
            });
        });
    }

    page(category: string, name: string, route: string, referrer: string, eventId: string) {
        var This = this;
        return new Promise(function (resolve) {
            var data = {
                page: route,
                title: category,
                referrer: null,
                eventId: null
            };

            if (referrer) {
                data.referrer = referrer;
            }

            if (typeof name === "string" && name.trim().length > 0) {
                data.title += " - " + name;
            }

            if (eventId) {
                data.eventId = eventId;
            }

            //This._ga("set", data);
            //This._ga("send", "pageview");
            //not passing any properties at this time
            This._segment("page", data, options(), function(){
                return resolve();
            });
        });
    }

    exception(description, fatal) {return Promise.resolve()}

    link(linkElementId, category, action, label, value, eventId) {return Promise.resolve()}

    push(obj: any) {
        var This = this;
        if (obj.type === "identify") {
            return This.identify(obj.userId, obj.profile);
        }
        else if (obj.type === "setEvent") {
            return This.dimension(1, obj.eventId);
        }
        else if (obj.type === "clearEvent") {
            return This.dimension(1, null);
        }
        else if (obj.type === "event") {
            return This.event(obj.category, obj.action, obj.label, obj.value, obj.extraInfo, obj.eventId);
        }
        else if (obj.type === "page") {
            return This.page(obj.category, obj.name, obj.route, obj.referrer, obj.eventId);
        }
        else if (obj.type === "link") {
            return This.link(obj.linkElementId, obj.category, obj.action, obj.label, null, obj.eventId);
        }
    }
};

